import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export interface OptOutItem {
  phone: string;
  reason: string;
  created_at: number;
}

type QueryResponse = {
  status: number;
  data: {
    optouts: OptOutItem[];
    total_count: number;
    limit: number;
    offset: number;
  };
};

export const createListOptOutsKey = (additional: any[] = []) => [
  'list-opt-outs',
  ...additional,
];

export const useListOptOutsQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while Listing WhatsApp Opt-Outs',
    endpoint: `/api/admin/whatsapp/optouts`,
  });

  return useQuery({
    queryKey: createListOptOutsKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};